export default __webpack_public_path__ + "resources/icons/d432-0647.webp";